import { useInvalidateOrganization } from "@/hooks/use-invalidate-organization";
import { AccountView } from "@papier/auth-ui";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/$accountView")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Account" }],
  }),
});

function RouteComponent() {
  const { accountView } = Route.useParams();
  const { trpc, queryClient } = Route.useRouteContext();
  const invalidateOrganization = useInvalidateOrganization();

  return (
    <AccountView
      pathname={accountView}
      onInvalidateInvitations={async () => {
        queryClient.invalidateQueries(trpc.authTrpc.getUserInvitations.queryFilter());
        queryClient.invalidateQueries(trpc.authTrpc.getUserOrganizations.queryFilter());
      }}
      onLeaveOrganizationSuccess={invalidateOrganization}
    />
  );
}
